import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 30px 60px 0 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
